import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Layout from './components/Layout';
import Compose from './pages/Compose';
import Logs from './pages/Logs';
import Admin from './pages/Admin';
import Settings from './pages/Settings';
import './styles.css';

function PrivateRoute({ children }) {
  const { currentUser, userProfile } = useAuth();
  // Not logged in
  if (!currentUser) return <Navigate to="/login" />;
  // Logged in but profile still loading — show nothing (no flash)
  if (!userProfile) return (
    <div style={{
      minHeight: '100vh', background: '#1a2340',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 16,
    }}>
      <svg width="48" height="48" viewBox="0 0 48 48" style={{ animation: 'spin 1s linear infinite' }}>
        <style>{'@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}'}</style>
        <circle cx="24" cy="24" r="18" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="4"/>
        <circle cx="24" cy="24" r="18" fill="none" stroke="#8B1A2E" strokeWidth="4"
          strokeDasharray="113" strokeDashoffset="80" strokeLinecap="round"/>
      </svg>
      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, fontFamily: 'system-ui,sans-serif' }}>Loading…</div>
    </div>
  );
  return children;
}

function AdminRoute({ children }) {
  const { userProfile } = useAuth();
  // Profile still loading — wait, don't redirect yet
  if (!userProfile) return null;
  // Profile loaded — check role
  return userProfile.role === 'admin' ? children : <Navigate to="/" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Compose />} />
            <Route path="logs" element={<Logs />} />
            <Route path="admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
